import { Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../../../../../components/checkbox/Checkbox";
import CustomInput from "../../../../../../../components/customInput/CustomInput";
import SmallDisplayInput from "../../../../../../../components/DisplayInput/SmallDisplayInput";
import RadioChoices from "../../../../../../../components/radioChoices/RadioChoices";
import CoursePick from "../../../../OdobrenjeAplikacija/PostKomentar/CoursePick";
import ColorCodedInput from "../ColorCodedInput";
import styles from "../EnrollmentForm.module.css";
import UserInfo from "../UserInfo";
import { attendanceMappingTP2 } from "../utils";

function TP2Form({
  userId,
  formMethodsFour,
  handleResetForm,
  programApplicationId,
  applicationsCreated,
  evidentionUserID,
  isAccepted,
  errorFields,
  application,
  commentModal,
  fetchApplicationCallback,
}) {
  const { watch, control } = formMethodsFour;
  const navigate = useNavigate();
  const getCourseContext = (course) => {
    return {
      userId,
      application,
      commentModal,
      course,
      evidentionUserID,
      fetchApplicationCallback,
    };
  };
  const getBackgroundColor = (fieldName, value) => {
    return attendanceMappingTP2[fieldName] >= Number(value)
      ? "#FEE8E8"
      : "#E8FEE8";
  };
  const choiceThreeTP2 = watch("choiceThreeTP2");
  const questionFourTP2 = watch("questionFourTP2");
  const questionFiveTP2 = watch("questionFiveTP2");
  return (
    <div>
      <div className={styles.formInputsContainer}>
        {userId !== "Polaznik" && (
          <UserInfo
            evidentionUserID={
              evidentionUserID ? evidentionUserID : application?.userId
            }
            course={"TP2"}
          />
        )}
        <p className={styles.formSectionText}>
          Pozdrav,u svrhu prijave za upis u Terapeutski praktikum 2
          &#40;TP2&#41; po pozivu koji ti je stigao e-mailom s referade i u
          kojem su navedeni termini radionica i predavanja molimo te da popuniš
          obrazac u nastavku.
          <br />
          <br />
          Za upis TP2 je preduvjet sudjelovanje na svim predavanjima programa
          Osobni razvoj kao i na minimalno 17 radionica po godini, a za eOR je
          obavezno sudjelovanje na minimalno 14 radionica po godini i svim
          Modulima uživo minimalno 5 radionica po modulu.
          <br />
        </p>
        <div className={styles.displayColumn}>
          <div className={styles.displayRow}>
            <ColorCodedInput
              name="TP2EvidentionOR1Lessons"
              labelText="1. godina OR - broj predavanja (6)"
              width="25%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
            <ColorCodedInput
              name="TP2EvidentionOR1Workshops"
              labelText="1. godina OR - broj radionica (min 17)"
              width="27%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
          </div>
          <div className={styles.displayRow}>
            <ColorCodedInput
              name="TP2EvidentionOR2Lessons"
              labelText="2. godina OR - broj predavanja (6)"
              width="25%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
            <ColorCodedInput
              name="TP2EvidentionOR2Workshops"
              labelText="2. godina OR - broj radionica (min 17)"
              width="27%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
          </div>
          <div className={styles.displayRow}>
            <ColorCodedInput
              name="TP2EvidentionOR3Lessons"
              labelText="3. godina OR - broj predavanja (6)"
              width="25%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
            <ColorCodedInput
              name="TP2EvidentionOR3Workshops"
              labelText="3. godina OR - broj radionica (min 17)"
              width="27%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
          </div>
          <div className={styles.displayRow}>
            <ColorCodedInput
              name="TP2EvidentionEOR1Lessons"
              labelText="1. godina eOR - broj predavanja (6)"
              width="25%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
            <ColorCodedInput
              name="TP2EvidentionEOR1Workshops"
              labelText="1. godina eOR - broj radionica (min 14)"
              width="27%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
            <ColorCodedInput
              name="TP2EvidentionEOR1LiveModule"
              labelText="1. godina eOR - broj Modula uživo (min 5)"
              width="29%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
          </div>
          <div className={styles.displayRow}>
            <ColorCodedInput
              name="TP2EvidentionEOR2Lessons"
              labelText="2. godina eOR - broj predavanja (6)"
              width="25%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
            <ColorCodedInput
              name="TP2EvidentionEOR2Workshops"
              labelText="2. godina eOR - broj radionica (min 14)"
              width="27%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
            <ColorCodedInput
              name="TP2EvidentionEOR2LiveModule"
              labelText="2. godina eOR - broj Modula uživo (min 5)"
              width="29%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
          </div>
          <div className={styles.displayRow}>
            <ColorCodedInput
              name="TP2EvidentionEOR3Lessons"
              labelText="3. godina eOR - broj predavanja (6)"
              width="25%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
            <ColorCodedInput
              name="TP2EvidentionEOR3Workshops"
              labelText="3. godina eOR - broj radionica (min 14)"
              width="27%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
            <ColorCodedInput
              name="TP2EvidentionEOR3LiveModule"
              labelText="2. godina eOR - broj Modula uživo (min 5)"
              width="29%"
              control={control}
              attendanceMapping={attendanceMappingTP2}
            />
          </div>
        </div>
        <br />
        <Controller
          control={formMethodsFour.control}
          name="checkOneTP2"
          render={({ field: { onChange, onBlur, value } }) => (
            <Checkbox
              onBlur={onBlur}
              error={errorFields.find((field) => field === "checkOneTP2")}
              onChange={
                userId !== "Referada" && !programApplicationId && onChange
              }
              value={value}
              disabled={applicationsCreated["TP2"] || evidentionUserID}
              label="Potvrđujem da sam u Moj profil pohranio skeniranu potvrdu o nekažnjavanju u kojoj je vidljivo da nisam pravomoćno osuđen/a za neko od kaznenih djela navedenih u Zakonu o djelatnosti psihoterapije."
            />
          )}
        />
        <Controller
          control={formMethodsFour.control}
          name="choiceOneTP2"
          render={({ field: { onChange, onBlur, value } }) => (
            <RadioChoices
              name="choiceOneTP2"
              onBlur={onBlur}
              error={errorFields.find((field) => field === "choiceOneTP2")}
              onChange={
                userId !== "Referada" &&
                !programApplicationId &&
                !evidentionUserID &&
                !applicationsCreated["TP2"]
                  ? onChange
                  : undefined
              }
              value={value}
              disabled={applicationsCreated["TP2"] || evidentionUserID}
              title="Imaš li riješene sve financijske obaveze prema školi od prethodnih godina što je preduvjet za upis TP2?"
              choices={[
                "Da",
                "Ne još, javit ću se računovodstvu (racunovodstvo@ipd-center.eu)",
              ]}
            />
          )}
        />
        <Controller
          control={formMethodsFour.control}
          name="choiceTwoTP2"
          render={({ field: { onChange, onBlur, value } }) => (
            <RadioChoices
              name="choiceTwoTP2"
              error={errorFields.find((field) => field === "choiceTwoTP2")}
              onBlur={onBlur}
              onChange={
                userId !== "Referada" &&
                !programApplicationId &&
                !evidentionUserID &&
                !applicationsCreated["TP2"]
                  ? onChange
                  : undefined
              }
              value={value}
              disabled={applicationsCreated["TP2"] || evidentionUserID}
              title="Uvjet za upis TP2 su ispunjene sve introspekcije prve tri godine koje si imao/la. Imaš li ispunjene sve introspekcije do sada?"
              choices={["Da", "Ne"]}
            />
          )}
        />
        <Controller
          control={formMethodsFour.control}
          name="questionTwoTP2"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomInput
              onBlur={onBlur}
              onChange={onChange}
              error={errorFields.find((field) => field === "questionTwoTP2")}
              value={value}
              name="questionTwoTP2"
              labelText="Uvjet za upis u TP2 je min 40 sati programskih terapija (IPR-a). Broj tvojih programskih terapija do današnjeg datuma unesenih u školski sustav:"
              placeholder="Upiši"
              disabled={true}
              backgroundColor={getBackgroundColor(
                "questionTwoTP2",
                formMethodsFour.watch("questionTwoTP2")
              )}
            />
          )}
        />
        <Controller
          control={formMethodsFour.control}
          name="questionThreeTP2"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomInput
              onBlur={onBlur}
              onChange={onChange}
              error={errorFields.find((field) => field === "questionThreeTP2")}
              value={value}
              name="questionThreeTP2"
              labelText="Ako si dobio/la uvjetan upis u TP2 (naknadno ispunjavanje uvjeta za terapije koje ti nedostaju) napiši broj terapija koje ti nedostaju i do kojeg datuma ti je mentor dao da ispuniš uvjete."
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["TP2"] ||
                evidentionUserID
              }
            />
          )}
        />
        <p className={styles.formSectionText} style={{ marginBottom: "-40px" }}>
          Uvjet za upis TP2 je iskustvo sudjelovanja tijekom TP1 kao pasivni
          promatrač u minimalnom broju sati: na Trijadama - 15, AG-Sovima - 9 i
          EPeR-ima - 6 ili ukupno min 30 sati, kako bi edukant mogao na početku
          TP2 sudjelovati u Trijadama kao terapeut.
        </p>
        <br />
        <div className={styles.displayRow}>
          <SmallDisplayInput
            value={formMethodsFour.watch("evidentionTRIJADA")}
            name="evidentionTRIJADA"
            labelText="Trijada"
            width={"9%"}
            backgroundColor={getBackgroundColor(
              "evidentionTRIJADA",
              formMethodsFour.watch("evidentionTRIJADA")
            )}
          />
          <SmallDisplayInput
            value={formMethodsFour.watch("evidentionAGS")}
            name="evidentionAGS"
            labelText="AGS"
            width={"8%"}
            backgroundColor={getBackgroundColor(
              "evidentionAGS",
              formMethodsFour.watch("evidentionAGS")
            )}
          />
          <SmallDisplayInput
            value={formMethodsFour.watch("evidentionEPER")}
            name="evidentionEPER"
            labelText="EPeR"
            width={"8%"}
            backgroundColor={getBackgroundColor(
              "evidentionEPER",
              formMethodsFour.watch("evidentionEPER")
            )}
          />
        </div>
        <Controller
          control={formMethodsFour.control}
          name="choiceThreeTP2"
          render={({ field: { onChange, onBlur, value } }) => (
            <RadioChoices
              name="choiceThreeTP2"
              error={errorFields.find((field) => field === "choiceThreeTP2")}
              onBlur={onBlur}
              onChange={
                userId !== "Referada" &&
                !programApplicationId &&
                !evidentionUserID &&
                !applicationsCreated["TP2"]
                  ? onChange
                  : undefined
              }
              value={value}
              disabled={applicationsCreated["TP2"] || evidentionUserID}
              title="Upisani TP2 program plaćam kao:"
              choices={["Privatna osoba", "Firma"]}
            />
          )}
        />
        {choiceThreeTP2 === "Firma" &&
          (!questionFiveTP2 || questionFiveTP2.trim() === "") && (
            <Controller
              control={formMethodsFour.control}
              name="questionFourTP2"
              render={({ field: { onChange, onBlur, value } }) => (
                <CustomInput
                  onBlur={onBlur}
                  onChange={onChange}
                  error={errorFields.find(
                    (field) => field === "questionFourTP2"
                  )}
                  value={value}
                  name="questionFourTP2"
                  labelText="Kao firma iz Hrvatske navodim adresu, grad i državu sjedišta firme i oib firme:"
                  placeholder="Upiši"
                  disabled={
                    userId === "Referada" ||
                    programApplicationId ||
                    applicationsCreated["TP2"] ||
                    evidentionUserID
                  }
                />
              )}
            />
          )}
        {choiceThreeTP2 === "Firma" &&
          (!questionFourTP2 || questionFourTP2.trim() === "") && (
            <Controller
              control={formMethodsFour.control}
              name="questionFiveTP2"
              render={({ field: { onChange, onBlur, value } }) => (
                <CustomInput
                  onBlur={onBlur}
                  onChange={onChange}
                  error={errorFields.find(
                    (field) => field === "questionFiveTP2"
                  )}
                  value={value}
                  name="questionFiveTP2"
                  labelText="Kao firma iz drugih država (osim Hrvatske) navodim adresu, grad i državu sjedišta firme i važeći vat broj firme iz eu (u slučaju da nemate važeći VAT broj, račun smo obavezni izdati na ime i prezime polaznika sukladno članku 196. direktive vijeća 2006/112/ez i članku 75. stavka 1. točke 6. zakona o porezu na dodanu vrijednost):"
                  placeholder="Upiši"
                  disabled={
                    userId === "Referada" ||
                    programApplicationId ||
                    applicationsCreated["TP2"] ||
                    evidentionUserID
                  }
                />
              )}
            />
          )}
        <Controller
          control={formMethodsFour.control}
          name="questionSixTP2"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomInput
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              name="questionSixTP2"
              labelText="Ovdje možeš upisati svoju napomenu ili eventualno dodatno pitanje:"
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["TP2"] ||
                evidentionUserID
              }
            />
          )}
        />
      </div>
      {userId === "Polaznik" && (
        <p
          className={styles.opisP}
          style={{
            marginLeft: 80,
            marginRight: 80,
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          Više o tome što se očekuje od polaznika kao osobni preduvjeti za upis
          u TP možeš pročitati u rubrici Dokumenti - KRITERIJI KOD EVALUACIJE
          POLAZNIKA ZA UPIS U 3. STUPANJ EDUKACIJE: TERAPEUTSKI PRAKTIKUM (TP)
        </p>
      )}
      {userId !== "Referada" && !programApplicationId && !evidentionUserID && (
        <div className={styles.formButtonsContainer}>
          {!applicationsCreated["TP2"] && (
            <div
              className={
                userId === "Referada"
                  ? `${styles.disabled} ${styles.cancelButton}`
                  : styles.cancelButton
              }
              onClick={() => {
                if (userId !== "Referada" && !programApplicationId) {
                  formMethodsFour.reset();
                  navigate(-1);
                }
              }}
              disabled={true}
            >
              odustani
            </div>
          )}
          <div
            className={
              userId === "Referada" || applicationsCreated["TP2"]
                ? `${styles.disabled} ${styles.sendButton}`
                : styles.sendButton
            }
            onClick={() => {
              if (userId !== "Referada") handleResetForm(formMethodsFour);
            }}
            disabled={applicationsCreated["TP2"]}
          >
            {applicationsCreated["TP2"] ? "Poslano" : "Pošalji prijavu"}
          </div>
        </div>
      )}
      <CoursePick context={getCourseContext("TP2")} />
      {userId === "Polaznik" &&
        !evidentionUserID &&
        !programApplicationId &&
        applicationsCreated["TP2"] && (
          <>
            {isAccepted["TP2"] !== false && (
              <div
                className={styles.acceptanceContainer}
                style={{
                  backgroundColor:
                    isAccepted["TP2"] === true &&
                    commentModal["TP2"]?.isReferadaAccepted === true
                      ? "#e8fee8"
                      : "#F8F9FB",
                }}
              >
                {isAccepted["TP2"] === true &&
                commentModal["TP2"]?.isReferadaAccepted === true
                  ? "Primljeni ste"
                  : "Vaša aplikacija je zaprimljena"}
              </div>
            )}
          </>
        )}
    </div>
  );
}

export default TP2Form;
